import React from 'react';

export default function FlashcardSetList({ sets, onSelectSet }) {
  if (!sets || sets.length === 0) return <p>No flashcard sets available.</p>;

  return (
    <ul style={{ listStyle: 'none', padding: 0 }}>
      {sets.map((set) => (
        <li key={set.id} style={{ margin: '10px 0' }}>
          <button
            onClick={() => onSelectSet(set)}
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              borderRadius: '6px',
              border: '1px solid #888',
              backgroundColor: '#f9f9f9'
            }}
          >
            {set.name}
          </button>
        </li>
      ))}
    </ul>
  );
}
